<template>
  <div class="ForgotPassword pointer">
    <NavBar title="重置密码" />
    <div class="main">
      <div class="shoujihao">
        <span class="inputBoxName">手机号</span>
        <van-cell-group :class="['inputBox']">
          <van-field
            label="+86"
            class="inputBack"
            v-model="phone"
            type="tel"
            placeholder="请输入手机号"
            maxlength="11"
          />
        </van-cell-group>
      </div>
      <button class="fsyzm_btn" @click="getyanzhengma">发送验证码</button>
    </div>
  </div>
</template>
  
  <script>
import { Toast } from "vant";
import NavBar from "@/components/NavBar.vue";
import { getsendCode } from "@/api/login";

export default {
  name: "ForgotPassword",
  components: {
    NavBar,
  },
  data() {
    return {
      phone: "",
    };
  },

  mounted() {},

  methods: {
    // 获取验证码
    getyanzhengma() {
      const phoneReg = /^1[3456789]\d{9}$/;
      if (!phoneReg.test(this.phone)) {
        Toast("手机号错误！请重新输入");
      } else {
        let data = {
          mobile: this.phone,
          businessType: "passwordLogin",
        };
        getsendCode(data).then((res) => {
          if (res.code == 200) {
            Toast("验证码已发送至您的手机");
            this.$router.push({
              path: "/setPassword",
              query: {
                phone: this.phone,
                title: "重置密码",
              },
            });
          }
        });
      }
    },
  },
};
</script>
  
  <style lang="less" scoped>
.ForgotPassword {
  width: 100%;
  height: 100%;
  background: #fff;
}
.main {
  padding: 30px 30px;
  text-align: left;
  .shoujihao {
    // height: 72px;
    font-size: 16px;
    margin-top: 16px;
    .inputBoxName {
      color: #333;
      font-size: 16px;
      font-weight: 700;
    }
    .inputBox {
      background-color: #f4f4f4;
      border-radius: 79px;
      overflow: hidden;
      margin-top: 10px;
      height: 48px;
      display: flex;
      align-items: center;
      .inputBack {
        background-color: #f4f4f4;
      }
      /deep/.van-field__label {
        width: 30px;
        display: flex;
        align-items: center;
        margin-right: 0;
      }
    }
  }
  .fsyzm_btn {
    width: 100%;
    border: none;
    height: 44px;
    font-size: 16px;
    margin-top: 30px;
    font-weight: 500;
    color: #ffffff;
    background: #886df3;
    border-radius: 30px;
  }
}
</style>